import { useState, useEffect } from "react";
import SigninForm from "../components/SigninForm";
import ResetPassword from "../components/ResetPassword";
import { useParams } from "react-router-dom";

export const LoginPage = () => {
  //#region HOOKS
  const params = useParams();

  //#endregion HOOKS

  //#region USESTATE
  const [isAnimated, setIsAnimated] = useState(false);
  const [loginState, setLoginState] = useState(false);
  //#endregion USESTATE

  //#region FUNCIONES

  //#endregion FUNCIONES

  //#region USEEFFECT
  useEffect(() => {
    if (params.Token) {
      if (params.Text === "RecoverPassword") {
        setLoginState(2);
        return;
      }
    }
    if (params.Text) {
      switch (params.Text) {
        case "RecoverPassword":
          if (params?.Token) {
            setLoginState(2);
            return;
          } else {
            setLoginState(1);
            return;
          }
      }
    }
    setLoginState(0);
  }, [params]);
  //#endregion USEEFFECT

  return (
    <div
      className={`flex w-[100%] sm:w-full h-full items-center justify-center bg-cover bg-no-repeat bg-login-img`}
    >
      <div className="h-full w-full relative flex items-center justify-center">
        <div
          className={`absolute w-[70%] md:w-[50%] xl:w-1/4 z-30 transition-all ease-in-out duration-300 h-fit
            ${loginState === 0 && "opacity-0 -translate-y-[500%] "}      
            `}
        >
          <ResetPassword
            loginState={loginState}
            setLoginState={setLoginState}
            Token={params?.Token}
            setIsAnimated={setIsAnimated}
          />
        </div>
        <div
          id="signin"
          className={` absolute top-0 left-0 h-[70%] sm:h-full w-full sm:w-1/2 flex justify-center items-center transition-all duration-500 ease-in-out z-20 pt-20
                ${loginState ? "-translate-x-full opacity-0" : ""}

                ${isAnimated ? "-translate-x-full opacity-0" : ""} `}
        >
          <div className="h-full w-3/4 md:w-full flex justify-center items-center relative">
            <SigninForm setLoginState={setLoginState} />
          </div>
        </div>
        <div
          id="overlay-container"
          className={`absolute top-0 w-full left-1/2  sm:left-1/2 sm:w-1/2 h-full sm:overflow-hidden transition-all duration-500 ease-in-out z-100
                    ${
                      isAnimated
                        ? "-translate-x-full"
                        : "-translate-x-1/2 sm:translate-x-0"
                    }`}
        >
          <div
            id="overlay"
            className={`bg-transparent relative left-0 sm:-left-full h-full w-full sm:w-[200%] transform overflow-hidden transition-all duration-500 ease-in-out ${
              isAnimated ? "translate-x-1/2" : "translate-x-0"
            }`}
          >
            <div
              id="overlay-right"
              className={` w-fit sm:w-1/2 h-[30%] sm:h-full absolute flex justify-center items-center top-[70%] sm:top-0 right-0 transform transition-all duration-500 ease-in-out sm:pt-32
                                ${loginState ? "translate-y-[200%]" : ""}
                                
                                ${
                                  isAnimated
                                    ? "translate-x-[150%] sm:translate-x-full"
                                    : "-translate-x-14 sm:translate-x-0"
                                }`}
            >
              <div className="!h-2/5 w-3/5 bg-no-repeat bg-logo-company-white bg-contain bg-center" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
